import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Retry3({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="20" cy="20" r="19.3" />
        <path d="M27.556 24A4.442 4.442 0 0 0 32 19.556M27.556 15.111A4.442 4.442 0 0 1 32 19.556M24 15.111l3.556 1.778v-3.556z" />
      </g>
      <path
        className={cx(theme.fill, theme.numberFill, theme.secondFill)}
        d="M13.8 19.228h1.809c.918 0 1.569-.23 1.95-.69.383-.458.574-1.098.574-1.918 0-.877-.217-1.543-.652-1.999-.435-.455-1.076-.683-1.925-.683-.806 0-1.453.236-1.94.71-.487.473-.73 1.102-.73 1.887h-1.989l-.02-.063c-.036-1.157.383-2.14 1.256-2.95s2.014-1.214 3.423-1.214c1.417 0 2.545.377 3.387 1.13.841.754 1.262 1.828 1.262 3.224 0 .63-.191 1.26-.573 1.887-.383.628-.956 1.106-1.72 1.436.919.301 1.569.775 1.951 1.42a4.17 4.17 0 0 1 .573 2.166c0 1.395-.457 2.493-1.372 3.292-.915.8-2.084 1.199-3.508 1.199-1.402 0-2.559-.377-3.47-1.13-.912-.754-1.35-1.776-1.315-3.066l.032-.063h1.977c0 .806.247 1.447.741 1.924.495.477 1.173.715 2.035.715.877 0 1.564-.238 2.062-.715.497-.477.746-1.181.746-2.114 0-.946-.22-1.644-.662-2.093-.442-.448-1.14-.673-2.093-.673H13.8v-1.62z"
      />
    </svg>
  )
}

Retry3.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
